export const indexsum = value => {
  return value > 99 ? "99+" : value;
};

export const file = value => {
  if (value != null) {
    return JSON.parse(value).showname;
  }
};
export const filepath = value => {
  console.log(value);
  if (value != null) {
    return "https://mscyeserver.mscye.com" + JSON.parse(value).filepath;
  }
};



// WEBPACK FOOTER //
// ./src/util/filter.js